import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/axiosInstance";

// ---------------------fetch-subAdmin-listing--------------------------
export const fetchSubadminListApi = async (data) => {
  const endPoint =
    `/admin/auth/list` + "?" + new URLSearchParams({ ...data }).toString();

  return await axios.get(endPoint, setJwtToken());
};

// SubAdmin Details API
export const subAdminDetailApi = async (data) => {
  const endPoint =
    `/admin/auth/details` + "?" + new URLSearchParams({ ...data }).toString();

  return await axios.get(endPoint, setJwtToken());
};

//--------------------------Add SubAdmin---------------------
export const addSubadminApi = async (reqData) => {
  const endPoint = `/admin/auth/sign_up`;
  return await axios.post(endPoint, reqData, setJwtToken());
};

//--------------------------Update SubAdmin---------------------
export const updateSubadminApi = async (reqData) => {
  const endPoint = `/admin/auth/update`;
  return await axios.put(endPoint, reqData, setJwtToken());
};
//--------------------------update SubAdmin status---------------------
export const updateSubadminStatus = async (reqData) => {
  const endPoint = `/admin/auth/status_update`;
  return await axios.put(endPoint, reqData, setJwtToken());
};
